
const translateItemTitle = (title, lang) => {
  let newTitle = title
  if (lang === 'nl') {
    if (title.indexOf('Subscription, incl. 1 Administrator user') === 0) {
      newTitle = title.replace('Subscription, incl. 1 Administrator user', 'Abonnement, incl. 1 volledige gebruiker')
    } else if (title.indexOf('Subscription, Rodeo planner') === 0) {
      newTitle = title.replace('Subscription, Rodeo planner', 'Rodeo Planner')
    } else if (title.indexOf('Subscription, incl. 1 Full user') === 0) {
      newTitle = title.replace('Subscription, incl. 1 Full user', 'Volledige gebruikers in je account')
    } else if (title.indexOf('Subscription, incl. 1 Standard user') === 0) {
      newTitle = title.replace('Subscription, incl. 1 Standard user', 'Standaard gebruikers in je account')
    } else if (title.indexOf('Standard users in your account') === 0) {
      newTitle = title.replace('Standard users in your account', 'Standaard gebruikers in je account')
    } else if (title.indexOf('Full users in your account') === 0) {
      newTitle = title.replace('Full users in your account', 'Volledige gebruikers in je account')
    } else if (title.indexOf('Post paid') === 0) {
      newTitle = title.replace('Post paid', 'Nieuwe')
        .replace(' added ', ' toegevoegd op ')
        .replace('standard user', 'standaard gebruiker')
        .replace('full user', 'volledige gebruiker')
    }
  } else {
    if (title.indexOf('Subscription, Rodeo planner') === 0) {
      newTitle = title.replace('Subscription, Rodeo planner', 'Rodeo Planner')
    }
  }

  return newTitle
}

module.exports = {
  translateItemTitle
}
